// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"a95d257397cb80e8","3625":"7bec47befaa5fca3","6436":"7bec47befaa5fca3","6973":"7bec47befaa5fca3","7660":"7bec47befaa5fca3","7741":"7bec47befaa5fca3"}[chunkId] + ".css";
};